module.exports = __webpack_public_path__ + "media/img/corporate/story_2-784c04a8c97d9a8f96eb448fe0f2128d.png";